import React from "react";

export default ({ img, width, height }) => {
  return (
    <img className="rounded-user-pic" style={{ width, height }} src={img} />
  );
};
